/**
 * Centralized Z-Index Management System
 *
 * This file defines all z-index values used throughout the application
 * to prevent stacking conflicts and provide semantic meaning.
 *
 * Layer Structure:
 * - Background: -10 to -1 (map tiles, backgrounds)
 * - Base: 0 to 19 (normal UI, panels, toolbars)
 * - Elevated: 20 to 39 (dropdowns, tooltips, popovers)
 * - Overlays: 40 to 59 (temporary overlays, loading screens)
 * - Modals: 100 to 119 (dialogs, modals, sidebars)
 * - Critical: 200+ (notifications, alerts, error messages)
 */

export const Z_INDEX = {
  // Background Layer
  MAP_BACKGROUND: -1,

  // Base Layer
  BASE: 0,
  HEADER: 102,
  HEADER_MENU: 103,
  MAP_CONTROLS: 10,
  // Default DOM marker layer (photos, ad-hoc drag handles, etc.)
  MAP_MARKERS: 12,
  // Waypoint markers should sit below photo markers/clusters.
  MAP_MARKERS_WAYPOINT: 11,
  MAP_MARKERS_CLUSTER: 13,
  // Route points should stay above other marker types while editing/routing.
  MAP_MARKERS_ROUTE_POINT: 14,
  TOOLBAR: 15,
  // Decorative, non-interactive brand wordmark debossed onto the map at top-center. Above the map
  // chrome band, well below every sheet/dropdown/modal so it never covers interactive UI.
  MAP_WORDMARK: 16,

  // Elevated Layer
  DROPDOWN: 20,
  TOOLTIP: 25,
  POPOVER: 30,

  // Overlay Layer
  LOADING_OVERLAY: 40,
  BACKDROP: 45,
  TEMPORARY_OVERLAY: 50,
  MOBILE_TOOLBAR: 55,
  MOBILE_TOOLBAR_DROPDOWN: 59,
  // Persistent mobile bottom tab bar; floats above the bottom-sheet panel (MOBILE_TOOLBAR).
  MOBILE_TAB_BAR: 57,
  MAP_LAYERS_PANEL: 58,
  LANDING_OVERLAY: 60,
  // Contextual mobile action sheets must sit above app chrome but below modals/dialogs.
  MOBILE_ACTION_SHEET: 100,

  // Modal Layer
  SIDEBAR: 100,
  MODAL: 105,
  DIALOG: 110,

  // Critical Layer
  NOTIFICATION: 200,
  TOAST: 205,
  ERROR_BOUNDARY: 210,
  SYSTEM_ALERT: 999,
} as const
